export default {
    common: {
        stripTags (str) {
            return str.replace(/<[^>]+>/g, ' ');
        }
    },
    messages: {
        parse (messages) {
            return messages.map(item => {
                return {
                    id: item.id,
                    title: item.title,
                    content: item.content,
                    state: 'new'
                }
            });
        }
    }
}